import { Form, Formik } from 'formik';
import React, { memo, useCallback, useEffect } from 'react';
import { initialFilterValues } from 'v2/interfaces/rating';
import producerRatingService from 'v2/services/rating/producer';

import type { IFilter } from 'v2/interfaces/rating';

import Fields from './Fields';
import styles from './styles';

import type { FormikProps } from 'formik';

const Filters = memo(() => {
  const classes = styles();

  useEffect(() => {
    producerRatingService.setFilter(initialFilterValues);
  }, []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    for (let v in values) {
      if (!values[v] || values[v] === null || values[v] === '') {
        delete values[v];
      }
    }
    producerRatingService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <div className={classes.filters}>
      <Formik initialValues={initialFilterValues} onSubmit={onSubmit}>
        {() => (
          <Form>
            <Fields />
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default Filters;
